import { useProduct, useProductAnalytics } from '../model'
import { AnalyticsForm, AnalitycsResult } from './Analytics'
import { ProductData } from './ProductData'

export const AnalyticsPage = () => {
    const analytics = useProductAnalytics()
    const { isLoading, error } = useProduct()

    if (isLoading || error) {
        return null
    }

    return (
        <div className='relative w-full flex flex-col md:flex-row gap-[20px]'>
            <div className='order-2 md:order-none flex flex-col gap-3 items-start w-full md:w-[50%]'>
                <ProductData
                    suggestedBrand={analytics.validationResult?.brand}
                    analyticsGenerationId={analytics.generationId}
                    isAnalyticsCompleted={
                        analytics.detailQuery.data?.status === 'completed' ||
                        analytics.detailQuery.data?.status === 'failed'
                    }
                />
            </div>
            <div className='order-1 md:order-none rounded-xl w-full md:w-[50%] flex flex-col gap-3 items-start'>
                <AnalyticsForm analytics={analytics} />
                <AnalitycsResult analytics={analytics} />
            </div>
        </div>
    )
}
